import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Attachments } from 'types'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'

export interface UploadedAttachment {
  name: string
  url: string
  mimeType: string
  thumbnailLink?: string
  iconLink?: string
}
export interface UploadNoteAttachmentsParams {
  files: File[]
  orgId?: string
  PK?: string
  SK?: string
}

export const useUploadNoteAttachments = (): UseMutationResult<
  Attachments[],
  Error,
  UploadNoteAttachmentsParams,
  unknown
> => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  return useMutation<Attachments[], Error, UploadNoteAttachmentsParams>({
    mutationFn: async ({ files, orgId, PK, SK }) => {
      const formData = new FormData()
      files.forEach(file => formData.append('files', file))

      if (orgId) formData.append('orgId', orgId)
      if (PK && SK) {
        formData.append('PK', PK)
        formData.append('SK', SK)
      }

      const response = await axios.post(`${baseUrl}/aws/s3/attachments/upload`, formData)
      return response.data.uploaded
    },

    onSuccess: uploaded => {
      showSnackbar('Attachments uploaded successfully', 'success')
    },

    onError: err => {
      console.error('Upload error:', err)
      showSnackbar('Attachment upload failed', 'error')
    },
  })
}
